import React from "react";

export function Toggle({ options, value, onChange }) {
  return (
    <div className="flex justify-center">
      <div className="p-1 bg-gray-200 rounded-full">
        <div className="relative flex shadow-sm">
          {options.map((option) => (
            <button
              key={option.value}
              onClick={() => onChange(option.value)}
              className={`
                z-10 px-8 py-2.5 rounded-full transition-all duration-300
                ${value === option.value ? "text-black" : "text-gray-500 hover:text-gray-700"}
              `}
            >
              {option.label}
            </button>
          ))}
          <div
            className={`
              absolute top-0 h-full w-1/2 bg-white rounded-full transition-all duration-300
              transform
              ${value === options[1].value ? "translate-x-full" : "translate-x-0"}
            `}
          />
        </div>
      </div>
    </div>
  );
}
